import React from 'react';
import './pagestyles/Opinion.css';
import BottomBanner from './BottomBanner';

const Opinion = () => {
  return (
      <>
    <div className="page-container">
      <div className="page-header">
        <h1>Opinion</h1>
        <p className="page-subtitle">Commentary and analysis from our columnists</p>
      </div>
      
      <div className="page-content">
        <div className="content-grid">
          <article className="article-card opinion-card">
            <div className="article-content">
              
              <h2>The Real Cost of Economic Populism</h2>
              <p>Short-term political gains often come at the expense of long-term economic stability. Here's why policymakers should resist the temptation.</p>
              <span className="article-author">By Sarah Johnson, Columnist</span>
              <span className="article-meta">1 hour ago</span>
            </div>
          </article>

          <article className="article-card opinion-card">
            <div className="article-content">
              
              <h2>Why Tech Regulation is Inevitable</h2>
              <p>The era of self-regulation in technology is over. Governments worldwide are stepping in, and here's what that means for innovation.</p>
              <span className="article-author">By Michael Chen, Senior Editor</span>
              <span className="article-meta">3 hours ago</span>
            </div>
          </article>

          <article className="article-card opinion-card">
            <div className="article-content">
              
              <h2>The Green Transition Won't Be Easy</h2>
              <p>Moving to renewable energy requires more than good intentions. It demands massive investment and difficult trade-offs.</p>
              <span className="article-author">By David Martinez, Columnist</span>
              <span className="article-meta">5 hours ago</span>
            </div>
          </article>

          <article className="article-card opinion-card">
            <div className="article-content">
             
              <h2>Rethinking Globalization in 2026</h2>
              <p>The old model of global trade is being challenged. What comes next will reshape international business for decades.</p>
              <span className="article-author">By Emily Roberts, Chief Economist</span>
              <span className="article-meta">7 hours ago</span>
            </div>
          </article>
        </div>
      </div>
    </div>
    <BottomBanner />
        </>
  );
};

export default Opinion;
